import { render, staticRenderFns } from "./BillToCommodities.vue?vue&type=template&id=c16fc3ac"
import script from "./BillToCommodities.vue?vue&type=script&lang=ts"
export * from "./BillToCommodities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports